import React, { FC } from 'react';
import Button from '../../Shared/Button/Button';
import Busy from '../../Shared/Busy';
import CanvasWithToolbar from '../Canvas/CanvasWithToolbar';
import styles from './CanvasContainer.module.scss';

type CanvasContainerProps = {
  busy: boolean;
  isSelectedBladeSideStitched: boolean;
  isSelectedBladeSideRejected: boolean;
  isStitchinInProgress: boolean;
  isStitchingFinished: boolean;
  isBladeSideSelected: boolean;
  areImagesAvailable: boolean;
  isToolbarBusy: boolean;
  images: any[];
  subsampleFactor: number;
  turbine: string;
  canStitch: boolean;
  onSaveImage: (images: any[], finish: boolean) => void;
  onRejectSequence: () => void;
  onChooseAnotherTurbine: () => void;
  onImagesLoaded: () => void;
};

const CanvasContainer: FC<CanvasContainerProps> = ({
  busy,
  isSelectedBladeSideStitched,
  isSelectedBladeSideRejected,
  isStitchinInProgress,
  isStitchingFinished,
  isBladeSideSelected,
  areImagesAvailable,
  isToolbarBusy,
  images,
  subsampleFactor,
  turbine,
  canStitch,
  onSaveImage,
  onChooseAnotherTurbine,
  onRejectSequence,
  onImagesLoaded
}) => {
  const isStichingAllowed = !(isStitchinInProgress || isStitchingFinished);

  return (
    <div className={styles.canvasContainer}>
      {!busy && !isStichingAllowed && (
        <div className={styles.goToHome}>
          <span>{isStitchinInProgress ? `Turbine ${turbine} stitching is in progress` : `Turbine ${turbine} was already stiched`}</span>
          <Button type='submit' title='Click here to choose another turbine' onClick={onChooseAnotherTurbine} disabled={false} />
        </div>
      )}
      {!busy && isBladeSideSelected && isStichingAllowed && areImagesAvailable && (
        <CanvasWithToolbar
          id='canvas'
          images={images}
          subsampleFactor={subsampleFactor}
          isStitched={isSelectedBladeSideStitched}
          isRejected={isSelectedBladeSideRejected}
          onSaveImage={onSaveImage}
          onImagesLoaded={onImagesLoaded}
          onRejectSequence={onRejectSequence}
          isToolbarBusy={isToolbarBusy}
          canStitch={canStitch}
        />
      )}
      {busy && <Busy />}
    </div>
  );
};

export default CanvasContainer;
